import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { FormGroup } from 'reactstrap'
import { enableBasicSumAssured, isInvalid } from 'common-components/view-logic'

import BasicSumAssured from './basic-sum-assured'
import BasicPremium from './basic-premium'
import BasicPlanErrorMessages from './basic-plan-error-messages'

import {
  getReadOnlyFields,
  haveBasicPremiumState,
  getSumAssured$,
  getBasicPremium$,
  getBasicPremiumState,
  getCampaignDiscountMessage,
  getCampaignDiscountEndDate,
} from 'quick-quote/product-common/coverage-plan/selectors'

import { editBasicPremiumState, editSumAssured } from 'quick-quote/product-common/coverage-plan/actions'

export const BasicPlan = ({
  basicPremiumState,
  haveBasicPremiumState,
  sumAssured$,
  basicPremium$,
  basicPremiumInfo,
  campaignDiscountEndDate,
  readOnlyFields,
  editSumAssured,
  editBasicPremium,
}) => {
  const isInvalidState = isInvalid(haveBasicPremiumState, sumAssured$, basicPremium$) ? 'has-danger' : ''
  let basicPremiumInfoMessage = []
  if (basicPremiumInfo && basicPremiumInfo.length > 0 && basicPremiumInfo[0]) {
    basicPremiumInfoMessage = [basicPremiumInfo[0]]
  } else {
    basicPremiumInfoMessage = []
  }

  let updateReadOnlyFields = { ...readOnlyFields }
  /* don't disable field for now
  if (campaignDiscountEndDate) {
    updateReadOnlyFields.basicPremium = true
  }
  */

  return (
    <FormGroup className={`coverage-plan-calculation item basic ${isInvalidState}`}>
      <div className="sum-assured-input">
        <div className="form-group-title">
          <span className="form-group-title-text">สัญญาหลัก</span>
        </div>
        <div className="options option-labels">
          <label>จำนวนเงินเอาประกันภัย</label>
          <label>เบี้ยสัญญาหลัก</label>
        </div>
        <div className="options option-inputs">
          <div className="sum-assured">
            <BasicSumAssured
              isReadOnly={updateReadOnlyFields.basicSumAssured}
              sumAssured={sumAssured$.value}
              enabled={enableBasicSumAssured(haveBasicPremiumState, basicPremium$)}
              editSumAssured={editSumAssured}
            />
          </div>
          <div className="link">{haveBasicPremiumState ? '←' : '→'}</div>
          <div className="premium">
            <BasicPremium
              isReadOnly={updateReadOnlyFields.basicPremium}
              basicPremium={haveBasicPremiumState ? basicPremiumState : basicPremium$.value}
              editBasicPremium={editBasicPremium}
            />
          </div>
        </div>
        <BasicPlanErrorMessages
          haveBasicPremiumState={haveBasicPremiumState}
          sumAssured$={sumAssured$}
          basicPremium$={basicPremium$}
          basicPremiumInfo={basicPremiumInfoMessage}
        />
      </div>
    </FormGroup>
  )
}

const mapStateToProps = (state) => ({
  basicPremiumState: getBasicPremiumState(state),
  haveBasicPremiumState: haveBasicPremiumState(state),
  sumAssured$: getSumAssured$(state),
  basicPremium$: getBasicPremium$(state),
  basicPremiumInfo: getCampaignDiscountMessage(state),
  campaignDiscountEndDate: getCampaignDiscountEndDate(state),
  readOnlyFields: getReadOnlyFields(state),
})

const mapDispatchToProps = (dispatch) => ({
  editSumAssured: bindActionCreators(editSumAssured, dispatch),
  editBasicPremium: bindActionCreators(editBasicPremiumState, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(BasicPlan)
